// One geotag per job, captured on demand while reviewing. Stored per-photo
// so each exported record is self-describing, and it is optional throughout.
export async function captureGeotag({ timeoutMs = 10000 } = {}) {
  if (!("geolocation" in navigator)) {
    throw new Error("This device does not report its location.");
  }

  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      clearWatch();
      reject(new Error("Finding your location took too long. Try again."));
    }, timeoutMs);

    const done = (err, position) => {
      clearTimeout(timer);
      clearWatch();
      if (err) {
        reject(
          new Error(
            err.code === err.PERMISSION_DENIED
              ? "Location permission was denied. Enable it to stamp photos."
              : "Your location could not be read. Try again."
          )
        );
        return;
      }

      resolve({
        lat: Number(position.coords.latitude.toFixed(6)),
        lon: Number(position.coords.longitude.toFixed(6)),
        accuracy: Math.round(position.coords.accuracy),
        at: Date.now()
      });
    };

    const watch = navigator.geolocation.watchPosition(
      (position) => done(null, position),
      (error) => done(error),
      { enableHighAccuracy: true, maximumAge: 15000, timeout: timeoutMs }
    );

    function clearWatch() {
      navigator.geolocation.clearWatch(watch);
    }
  });
}

export function formatGeotag(gps) {
  if (!gps) return "";

  return `${gps.lat.toFixed(5)}, ${gps.lon.toFixed(5)} (±${gps.accuracy || "?"} m)`;
}
